import { Link } from '@mui/material';
import React from 'react';

export const FaqsConfiq = [
	{
		question: 'What is Affogato?',
		answer:
			'Affogato is an AI media creation platform that lets you generate ultra-realistic images and videos using virtual human characters. It’s designed for marketers, ecommerce brands, and agencies who want to create high-quality content without traditional shoots.',
	},
	{
		question: 'Is Affogato the same as RenderNet?',
		answer:
			'Yes! Affogato is the new name for RenderNet. It’s the same powerful platform—same team, same mission—with a fresh identity and even more exciting features on the way.',
	},
	{
		question: 'Why did you change the name from RenderNet to Affogato?',
		answer:
			'We wanted a name that better reflects the blend of AI (espresso) and creativity (gelato) that powers our platform. “Affogato” represents our vision to merge powerful technology with expressive storytelling—where content creation becomes both intelligent and deeply personal.',
	},
	{
		question: 'What can I create with Affogato?',
		answer:
			'You can create AI-generated videos, images, product marketing content, UGC-style ads, talking characters, and more. Whether you sell clothes, jewelry, cosmetics, or digital services—Affogato helps you create content that converts.',
	},
	{
		question: 'Can I create a custom AI character for my brand?',
		answer:
			'Yes! Affogato allows you to create bespoke AI characters that represent your brand. These characters can talk, pose, wear your products, and appear in videos for your campaigns.',
	},
	{
		question: 'Do I need technical or design experience to use Affogato?',
		answer:
			'Not at all. Affogato is built for marketers, creators, and business owners—not just designers or video editors. Our intuitive interface makes it easy for anyone to create professional-grade visuals.',
	},
	{
		question: 'How is Affogato different from other AI tools like Midjourney or HeyGen?',
		answer:
			'Affogato is purpose-built for commercial content—especially ecommerce and marketing. Unlike generic tools, we offer character consistency, product integration, and easy workflows for creating ad-ready videos.',
	},
	{
		question: 'Can I use Affogato for my Shopify, Amazon, or Etsy store?',
		answer:
			'Absolutely. Affogato helps ecommerce merchants create high-quality product visuals and videos featuring AI characters, perfect for boosting your store’s marketing and social media presence.',
	},
	{
		question: 'Is there a free trial or demo available?',
		answer:
			'We don’t offer a free trial, but you can get started with our low-cost trial plan at just $9/month. It’s a great way to explore the platform and see what you can create—no long-term commitment required.',
	},
	{
		question: 'Where can I get support if I have questions or issues?',
		answer: (
			<>
				You can reach us our live chat,
				<Link
					href="mailto:hello@affogato.ai"
					sx={{ color: 'colors.white', fontWeight: 'bold', textDecoration: 'none' }}
				>
					{' '}
					email
				</Link>{' '}
				or{' '}
				<Link
					href="https://discord.com/invite/rendernet-ai"
					sx={{ color: 'colors.white', fontWeight: 'bold', textDecoration: 'none' }}
					target="_blank"
					rel="noopener noreferrer"
				>
					Discord{' '}
				</Link>{' '}
				community. We’re here to help you create amazing content and make the most of Affogato.,
			</>
		),
	},
	{
		question: 'Does Affogato have an API?',
		answer: (
			<>
				{' '}
				Yes, Affogato offers an API for developers to build their own AI applications. You can
				access the API documentation{' '}
				<Link
					href="https://docs.rendernet.ai/api-reference/introduction"
					sx={{ color: 'colors.white', fontWeight: 'bold', textDecoration: 'none' }}
					target="_blank"
					rel="noopener noreferrer"
				>
					{' '}
					here{' '}
				</Link>
			</>
		),
	},
	{
		question: "How do I join the Affogato creators's community?",
		answer: (
			<>
				Visit
				<Link
					href="https://discord.com/invite/rendernet-ai"
					sx={{ color: 'colors.white', fontWeight: 'bold', textDecoration: 'none' }}
					target="_blank"
					rel="noopener noreferrer"
				>
					{' '}
					our Discord server{' '}
				</Link>
				to join the Affogato creators&#39; community.
			</>
		),
	},
];
